import React from 'react';
import { func, bool } from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import { message } from '../../../../../../../utils/stringUtils';
import { appConfig } from '../../../../../../../config/customization';
import { accountPropTypes } from '../../../../../../../redux/accountHandlers';

import QueryForm from './components/QueryForm';
import styles from './styles';

function QueryModal(props) {
  return !props.socialRateStatus ? (
    <QueryForm
      onSubmit={props.onSubmit}
      options={props.userAccounts}
      isPublicRequest={props.isPublicRequest}
    />
  ) : (
    <div style={styles.queryResult}>
      {appConfig.socialRate.showClientNumber && (
        <UTLabel semibold style={styles.clientNumber}>{`${message('Commons:clientNumber')} ${
          props.socialRateStatus.clientNumber
        }`}</UTLabel>
      )}
      {appConfig.socialRate.showAddress && props.socialRateStatus.address && (
        <UTLabel semibold>{`${message('Commons:address')}: ${props.socialRateStatus.address}`}</UTLabel>
      )}
      <UTLabel semibold>{props.socialRateStatus.message}</UTLabel>
    </div>
  );
}

QueryModal.propTypes = {
  onSubmit: func,
  socialRateStatus: bool,
  userAccounts: accountPropTypes,
  isPublicRequest: bool
};

export default WithLoading(props => props.loading, message('SocialRate:queryInProgress'))(QueryModal);
